import { styled } from 'styled-components'

export const Wrapper = styled.div`
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  margin-top: 16px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
    sans-serif;
  width: calc(100% - 32px);
  max-width: 380px;
  position: fixed;
  bottom: 16px;
  left: 16px;
  z-index: 9999;
  border-left: 4px solid;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 1.5;
  transition: all 0.2s ease;
  animation: slideUp 0.3s ease;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(16px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }
`

export const AlertContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const IconWrapper = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 12px;
  flex-shrink: 0;
`

export const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  color: inherit;
  font-size: 22px;
  cursor: pointer;
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 0;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  &:focus {
    outline: none;
  }
`

export const ProgressBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  border-bottom-right-radius: 8px;
  transition: width 16ms linear;
`
